import React from "react";
import BirthdayCard from "components/birthday/BirthdayCard";

const MainContent = (props) => {
  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        padding: "0px",
      }}
    >
      <BirthdayCard />
    </div>
  );
};

export default MainContent;
